import Component from './Widget1';

export default Component;
